module.exports = __webpack_public_path__ + "static/media/change-direction.eb2364ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/change-direction.svg
// module id = 231
// module chunks = 0